module.exports = __webpack_public_path__ + "img/icon-team-knowledge-diff.ba5a7f01.svg";